import PropTypes from 'prop-types';
import SelectField from './SelectField';
import { renderLocaleOptions } from '../services/renderOptions';
import getTargetAttribute from '../services/getTargetAttribute';

const propTypes = {
    disabled: PropTypes.bool,
    label: PropTypes.string,
    /**
     * Locales map holding locale keys and labels
     *
     * @example { en_US: 'United States', en_AU: 'Australia', en_CA: 'Canada' }
     */
    locales: PropTypes.shape({}),
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
};

const LocaleField = ({ disabled = false, label, locales, onChange, placeholder, value }) => {
    const options = renderLocaleOptions(locales);

    return (
        <SelectField
            onChange={onChange}
            label={label}
            value={value}
            disabled={disabled}
            placeholder={placeholder}
            data-target={getTargetAttribute('locale-field')}
        >
            {options}
        </SelectField>
    );
};

LocaleField.propTypes = propTypes;

export default LocaleField;
